import { render } from "./LichSuGiaoNhanHang.vue?vue&type=template&id=3ccc5b4e&scoped=true"
import script from "./LichSuGiaoNhanHang.vue?vue&type=script&lang=js"
export * from "./LichSuGiaoNhanHang.vue?vue&type=script&lang=js"

import "./LichSuGiaoNhanHang.vue?vue&type=style&index=0&id=3ccc5b4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccc5b4e"]])

export default __exports__